import { connect } from 'react-redux';

import { IAppState } from '../../../../../common/state';
import { changeCoworkingAccess } from '../../../../state/advanced/coworking_access';

import { getCoworkingAccessFromJsonQuery } from '../../../../../utils/coworkingAccess';

import { CoworkingAccess as CoworkingAccessComponent } from './CoworkingAccess';

export const mapStateToProps = (state: IAppState) => ({
  selected: getCoworkingAccessFromJsonQuery(state.filters.jsonQuery),
});

export const mapDispatchToProps = {
  onSelect: changeCoworkingAccess,
};

export const CoworkingAccess = connect(mapStateToProps, mapDispatchToProps)(CoworkingAccessComponent);
